<template>
    <div id="app">
        <el-row>
            <el-col :span="6">
                <el-form :model="baseInfo" label-width="80px">
                    <el-form-item label="域名">
                        <el-input v-model="baseInfo.baseUrl" placeholder="域名"></el-input>
                    </el-form-item>
                    <el-form-item label="租户token">
                        <el-input type="textarea" v-model="baseInfo.baseToken" placeholder="token"></el-input>
                    </el-form-item>
                    <!-- <el-form-item>
                    <el-button type="primary" @click="get_stuffRecord">查询</el-button>
                </el-form-item> -->
                </el-form>
            </el-col>
            <el-col :span="12" style="padding-left: 40px;">
                <el-row>
                    <el-button plain v-on:click="conmmonSetting('sit_Test')">sit测试</el-button>
                    <el-button plain v-on:click="conmmonSetting('uat_fz')">uat仿真</el-button>
                    <el-button plain v-on:click="conmmonSetting('prod_Test')">prod测试</el-button>
                    <el-button plain v-on:click="conmmonSetting('prod_NoToken')">prod无Token</el-button>
                </el-row>
            </el-col>
            <el-col :span="6" style="padding-left: 40px;">
                <div style="color: #99a9bf; text-align: right;">
                    <div>使用此工具须联网，否则组件无法加载</div>
                    <div>发现bug提Jira，可以共同维护</div>
                    <div>请勿泄漏生产环境Token，不要在代码写死</div>
                    <div>------</div>
                    <div>2022-8-10</div>
                </div>

            </el-col>
        </el-row>

        <el-tabs type="card">
            <el-tab-pane>
                <div slot="label" @click="get_weigh">等待称料</div>
                <el-button type="primary" @click="get_weigh">更新</el-button>
                <div>
                    <el-table :data="weigh_res" style="width: 100%" :default-sort="{prop: 'stuffCode', order: ''}">
                        <el-table-column prop="stuffCode" label="料单号" width="" sortable>
                        </el-table-column>
                        <el-table-column prop="stuffStepUid" label="料单步骤" width="" sortable>
                        </el-table-column>
                        <el-table-column prop="weighingStatus" label="称料状态" width="">
                        </el-table-column>
                        <el-table-column prop="weighingCode" label="称料代码" width="">
                        </el-table-column>
                        <el-table-column prop="deviceId" label="设备ID" width="">
                        </el-table-column>
                        <el-table-column prop="deviceName" label="设备名称">
                        </el-table-column>
                        <el-table-column fixed="right" label="操作" width="100">
                            <template slot-scope="scope">
                                <el-button @click="get_weigh_detail(scope.row.materialList)" type="text" size="small">查看
                                </el-button>
                                <!-- <el-button @click="handleClick(scope.row.materialList)" type="text" size="small">查看</el-button> -->
                                <!-- <el-button type="text" size="small">编辑</el-button> -->
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

            </el-tab-pane>

            <el-tab-pane>
                <div slot="label" @click="get_delivery">等待输料</div>

                <el-button type="primary" @click="get_delivery">更新</el-button>
                <div>
                    <el-table :data="delivery_res" style="width: 100%">
                        <el-table-column prop="stuffCode" label="料单号" width="180">
                        </el-table-column>
                        <el-table-column prop="stuffStepUid" label="料单步骤" width="180">
                        </el-table-column>
                        <el-table-column prop="batchNo" label="批次号" width="180">
                        </el-table-column>
                        <!-- <el-table-column prop="deviceId" label="设备ID" width="180">
                    </el-table-column> -->
                        <el-table-column prop="deviceName" label="设备名称" width="180">
                        </el-table-column>
                        <!-- <el-table-column prop="feedingPositionNo" label="加料位置" width="180">
                    </el-table-column> -->
                        <el-table-column prop="feedingPosition" label="加料位置名称" width="180">
                        </el-table-column>

                        <el-table-column prop="deliveryStatus" label="配送状态" width="180">
                        </el-table-column>
                        <el-table-column prop="deliveryCode" label="配送代码">
                        </el-table-column>
                        <el-table-column fixed="right" label="操作" width="100">
                            <template slot-scope="scope">
                                <el-button @click="get_weigh_detail(scope.row.materialList)" type="text" size="small">查看
                                </el-button>
                                <!-- <el-button type="text" size="small">编辑</el-button> -->
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

            </el-tab-pane>

            <el-tab-pane>
                <div slot="label" @click="get_stuffRecord">中间表全量数据</div>
                <el-form :inline="true" :model="formInline" class="demo-form-inline">
                    <el-form-item label="料单号">
                        <el-input v-model="formInline.stuffCode" placeholder="料单号" @clear="get_stuffRecord" clearable>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="批次号">
                        <el-input v-model="formInline.batchNo" placeholder="批次号" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="get_stuffRecord">查询</el-button>
                    </el-form-item>
                </el-form>
                <div>
                    <el-table :data="stuffRecord_res" style="width: 100%" size="">
                        <el-table-column prop="stuffCode" label="料单号" width="180">
                        </el-table-column>
                        <el-table-column prop="stuffStepUid" label="料单步骤" width="">
                        </el-table-column>
                        <el-table-column prop="batchNo" label="批次号" width="180">
                        </el-table-column>
                        <!-- <el-table-column prop="deviceId" label="设备ID" width="180">
                    </el-table-column> -->
                        <el-table-column prop="deviceName" label="设备名称" width="200">
                        </el-table-column>
                        <el-table-column prop="weighingStatus" label="称料状态" width="">
                        </el-table-column>
                        <el-table-column prop="weighingDesc" label="称料描述" width="">
                        </el-table-column>
                        <el-table-column prop="weighingCode" label="称料代码" width="">
                        </el-table-column>
                        <el-table-column prop="deliveryStatus" label="配送状态" width="">
                        </el-table-column>
                        <el-table-column prop="deliveryDesc" label="配送描述" width="">
                        </el-table-column>
                        <el-table-column prop="deliveryCode" label="配送代码" width="">
                        </el-table-column>
                        <el-table-column prop="feedingPositionNo" label="加料位置" width="">
                        </el-table-column>
                        <el-table-column prop="feedingPosition" label="加料位置名称" width="">
                        </el-table-column>

                        <el-table-column fixed="right" label="操作" width="100">
                            <template slot-scope="scope">
                                <el-button @click="get_stuffRecord_detail(scope.row)" type="text" size="small">更新
                                </el-button>
                                <!-- <el-button type="text" size="small">编辑</el-button> -->
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination background layout="total, prev, pager, next" :total="stuffRecord.total"
                        @current-change="handleCurrentChange" v-if="stuffRecord != ''"
                        style="text-align: right; margin-top: 16px;">
                    </el-pagination>
                </div>
            </el-tab-pane>

            <el-tab-pane>
                <div slot="label" @click="get_SyncList">云平台料单</div>
                <el-form :inline="true" :model="stuffRecord_list" class="demo-form-inline">
                    <el-form-item label="开始时间">
                        <el-input v-model="stuffRecord_list.startTime" placeholder="开始时间" @clear="" clearable>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="结束时间">
                        <el-input v-model="stuffRecord_list.endTime" placeholder="结束时间" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="deviceType">
                        <el-input v-model="stuffRecord_list.deviceType" placeholder="deviceType" @clear="" clearable>
                        </el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="get_SyncList">查询</el-button>
                    </el-form-item>
                </el-form>
                <div>
                    <el-table :data="stuffRecord_list.res_data" style="width: 100%" size=""
                        :default-sort="{prop: 'stuffCode', order: 'descending'}">
                        <el-table-column prop="stuffCode" label="料单号" width="180">
                        </el-table-column>
                        <el-table-column prop="batchNo" label="批次号" width="180">
                        </el-table-column>
                        <!-- <el-table-column prop="deviceId" label="设备ID" width="180">
                    </el-table-column> -->
                        <el-table-column prop="deviceName" label="设备名称" width="200">
                        </el-table-column>
                        <el-table-column prop="weight" label="布重" width="120">
                        </el-table-column>
                        <el-table-column prop="weightUnit" label="单位" width="">
                        </el-table-column>
                        <el-table-column prop="bathRatio" label="浴比" width="">
                        </el-table-column>
                        <el-table-column prop="liquidRatio" label="带液率" width="">
                        </el-table-column>
                        <el-table-column prop="waterVolume" label="水量(L)" width="">
                        </el-table-column>

                        <el-table-column fixed="right" label="操作" width="100">
                            <template slot-scope="scope">
                                <el-button @click="" type="text" size="small">查看
                                </el-button>
                                <!-- <el-button type="text" size="small">编辑</el-button> -->
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>
            <!-- 设备ID对应关系 -->
            <el-tab-pane>
                <div slot="label" @click="get_Device">设备ID对应关系</div>
                <!-- <el-button type="primary" @click="get_Device">刷新</el-button> -->

                <div>
                    <!-- <el-input v-model="device" placeholder="请输入内容"></el-input> -->
                    <el-input type="textarea" :autosize=true v-model="device" placeholder="加载中………………"></el-input>
                    <!-- <div>{{device}}</div>                     -->
                </div>
            </el-tab-pane>
        </el-tabs>
        <!-- Table 【称料】染化料详细 -->
        <el-dialog title="染化料详细" :visible.sync="get_weighTableVisible">
            <el-table :data="weigh_detail_res">
                <el-table-column property="stuffCode" label="料单" width="120"></el-table-column>
                <el-table-column property="sort" label="sort"></el-table-column>
                <el-table-column property="materialCode" label="染化料编号"></el-table-column>
                <el-table-column property="materialName" label="染化料名称" width="150"></el-table-column>
                <el-table-column property="materialType" label="类型"></el-table-column>
                <el-table-column property="materialGroup" label="分组"></el-table-column>
                <el-table-column property="ingredients" label="用量(g)" width="150"></el-table-column>
                <el-table-column property="feedingType.desc" label="加料方式"></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="get_weighTableVisible = false">取 消</el-button>
                <el-button type="primary" @click="get_weighTableVisible = false">确 定</el-button>
            </span>
        </el-dialog>
        <!-- Table 【输料】染化料详细 -->
        <el-dialog title="染化料详细" :visible.sync="get_deliveryTableVisible">
            <el-table :data="delivery_detail_res">
                <el-table-column property="stuffCode" label="料单" width="120"></el-table-column>
                <el-table-column property="sort" label="sort"></el-table-column>
                <el-table-column property="materialCode" label="染化料编号"></el-table-column>
                <el-table-column property="materialName" label="染化料名称" width="150"></el-table-column>
                <el-table-column property="materialType" label="类型"></el-table-column>
                <el-table-column property="materialGroup" label="分组"></el-table-column>
                <el-table-column property="ingredients" label="用量(g)" width="150"></el-table-column>
                <el-table-column property="feedingType.desc" label="加料方式"></el-table-column>
            </el-table>
        </el-dialog>
        <!-- Table 【中间表】染化料详细 -->
        <el-dialog title="染化料详细" :visible.sync="get_stuffRecordTableVisible" width="80%">
            <el-form :inline="true" :model="formInline" class="demo-form-inline">
                <!-- <el-form-item label="料单号">
                <el-input v-model="stuffRecord_res_select.stuffCode" placeholder="料单号" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="步骤">
                <el-input v-model="stuffRecord_res_select.stuffStepUid" placeholder="步骤" style="width:100px" :disabled="true"></el-input>
            </el-form-item> -->

                <el-form-item label="称料状态">
                    <el-input v-model="stuffRecord_res_select.weighingStatus" placeholder="称料状态"></el-input>
                </el-form-item>
                <el-form-item label="称料代码">
                    <el-input v-model="stuffRecord_res_select.weighingCode" placeholder="称料代码"></el-input>
                </el-form-item>
                <el-form-item label="称料开始时间">
                    <el-input v-model="stuffRecord_res_select.weighStartTime" placeholder="2022-08-10 00:00:00">
                    </el-input>
                </el-form-item>
                <el-form-item label="称料完成时间">
                    <el-input v-model="stuffRecord_res_select.weighEndTime" placeholder="完成时间"></el-input>
                </el-form-item>
                <div></div>
                <el-form-item label="配送状态">
                    <el-input v-model="stuffRecord_res_select.deliveryStatus" placeholder="配送状态"></el-input>
                </el-form-item>
                <el-form-item label="配送代码">
                    <el-input v-model="stuffRecord_res_select.deliveryCode" placeholder="配送代码"></el-input>
                </el-form-item>
                <el-form-item label="配送开始时间">
                    <el-input v-model="stuffRecord_res_select.deliveryStartTime" placeholder="配送开始时间"></el-input>
                </el-form-item>
                <el-form-item label="配送完成时间">
                    <el-input v-model="stuffRecord_res_select.deliveryEndTime" placeholder="配送完成时间"></el-input>
                </el-form-item>
            </el-form>
            <el-table :data="stuffRecord_detail_res">
                <el-table-column prop="stuffCode" label="料单" width="120"></el-table-column>
                <el-table-column prop="sort" label="sort"></el-table-column>
                <el-table-column prop="materialCode" label="染化料编号"></el-table-column>
                <el-table-column prop="materialName" label="染化料名称" width=""></el-table-column>
                <el-table-column prop="materialType" label="类型"></el-table-column>
                <el-table-column prop="materialGroup" label="分组"></el-table-column>
                <el-table-column prop="ingredients" label="用量(g)" width=""></el-table-column>
                <el-table-column prop="feedingType.desc" label="加料方式"></el-table-column>
                <el-table-column label="实际用量">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.actualIngredients" type="text" />
                    </template>
                </el-table-column>
                <el-table-column label="称料/配送状态">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.transferStatus" type="text" />
                    </template>
                </el-table-column>

            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="btn_update_weigh">更新称料</el-button>
                <el-button type="success" @click="btn_update_delivery">更新配送</el-button>
                <el-button @click="get_stuffRecordTableVisible = false">取 消</el-button>

            </span>
        </el-dialog>

    </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld'
const axios = require('axios').default;
export default {
    name: 'App',
    data() {
        return {
            baseInfo: {
                baseUrl: "http://202.105.21.100:18931",
                baseToken: "eyJ0eXAiOiJKc29uV2ViVG9rZW4iLCJhbGciOiJIUzI1NiJ9.eyJhcHBLZXkiOiI1MzBhNjNkMDI4MTc0NTljODA1MDJjNGVlNGU1ZThjMSIsInRlbmFudCI6IlRFU1QiLCJpYXQiOjE2NTg3MzEyMjgsIm5iZiI6MTY1ODczMTIyOCwiZXhwIjoyNjA0ODExMjI4fQ.mJTn8VyBBCSBySjq4D9e1RvowSXcTDRW8CdsVmtTdL0"
            },
            message: 'Hello Vue!',
            hello: "hello",
            weigh_res: [],
            delivery_res: [],
            stuffRecord_res: [],
            get_weighTableVisible: false,
            weigh_detail_res: "",
            get_deliveryTableVisible: false,
            delivery_detail_res: "",
            get_stuffRecordTableVisible: false,
            stuffRecord_detail_res: "",
            stuffRecord_res_select: "",
            formInline: {
                stuffCode: '',
                batchNo: ''
            },
            updateTableData: [{
                "actualIngredients": '',
                "transferStatus": '',
            }],
            stuffRecord: '',
            stuffRecord_page: 1,
            stuffRecord_list: {
                deviceType: "DYEING",
                endTime: Date.now(),
                startTime: Date.now() - (86400000 * 1) + 1000,
                res_data: []
            },
            device: ""
        }
    },
    methods: {
        handleClick(row) {
            console.log(row);
        },
        // 常用租户
        conmmonSetting(tenant) {
            const tenants = {
                sit_Test: {
                    url: "http://202.105.21.100:18931",
                    token: "eyJ0eXAiOiJKc29uV2ViVG9rZW4iLCJhbGciOiJIUzI1NiJ9.eyJhcHBLZXkiOiI1MzBhNjNkMDI4MTc0NTljODA1MDJjNGVlNGU1ZThjMSIsInRlbmFudCI6IlRFU1QiLCJpYXQiOjE2NTg3MzEyMjgsIm5iZiI6MTY1ODczMTIyOCwiZXhwIjoyNjA0ODExMjI4fQ.mJTn8VyBBCSBySjq4D9e1RvowSXcTDRW8CdsVmtTdL0"
                },
                uat_fz: {
                    url: "http://202.105.21.100:8931",
                    token: "eyJ0eXAiOiJKc29uV2ViVG9rZW4iLCJhbGciOiJIUzI1NiJ9.eyJhcHBLZXkiOiJjOTAzYTViNGE3MGU0YzJiYjNiNWI1MWZkNzA3ODEyZiIsInRlbmFudCI6IkZaIiwiaWF0IjoxNjUzMzA0ODIzLCJuYmYiOjE2NTMzMDQ4MjMsImV4cCI6MjU5OTM4NDgyM30.8MRl7tMioHbWuM4T8vMrkJlK7IUOPq8OeGfOPHKyIiw"
                },
                prod_Test: {
                    url: "https://internal-api.itexcloud.com:9005",
                    token: "eyJ0eXAiOiJKc29uV2ViVG9rZW4iLCJhbGciOiJIUzI1NiJ9.eyJhcHBLZXkiOiI1ODk5OWJkMGI4ZGE0YzllYWVlOGQ5M2VmZDhjNTliNCIsInRlbmFudCI6IlRFU1QiLCJpYXQiOjE2NTMzODkwMDEsIm5iZiI6MTY1MzM4OTAwMSwiZXhwIjoyNTk5NDY5MDAxfQ.LBT2grVnWM8ngpF1XDTS3mYE74EFxLmK3CjkcQhNZTw"
                },
                prod_NoToken: {
                    url: "https://internal-api.itexcloud.com:9005",
                    token: ""
                }

            }
            console.log(tenant)
            console.log(typeof (tenant))
            console.log(tenants[tenant].url)
            this.baseInfo.baseUrl = tenants[tenant].url
            this.baseInfo.baseToken = tenants[tenant].token
        },
        getYiyan: function () {
            let than = this
            axios.get("https://v1.hitokoto.cn")
                .then(function (res) {
                    than.hello = res.data.hitokoto
                    console.log(res)
                }, function (err) {
                    console.log(err)
                })
        },
        get_weigh() {
            const than = this
            axios.get(this.baseInfo.baseUrl + "/open/stuffRecord/weigh/get", {
                headers: { 'token': this.baseInfo.baseToken },
            })
                .then(res => {
                    if (res.data.code == 0) {
                        this.weigh_res = res.data.data
                        // console.log(res.data.data)
                        // than.$message({
                        //     message: res.data.msg,
                        //     type: 'success'
                        // });
                    } else {
                        than.$message({
                            message: res.data.msg,
                            type: 'error'
                        });
                    }

                })
                .catch(function (error) {
                    if (error.response) {
                        // 请求成功发出且服务器也响应了状态码，但状态代码超出了 2xx 的范围
                        console.log(error.response);
                        console.log(error.response.data);
                        console.log(error.response.status);
                        console.log(error.response.headers);
                    } else if (error.request) {
                        // 请求已经成功发起，但没有收到响应
                        // `error.request` 在浏览器中是 XMLHttpRequest 的实例，
                        // 而在node.js中是 http.ClientRequest 的实例
                        console.log(error.request);
                        console.log("error.request");
                    } else {
                        // 发送请求时出了点问题
                        console.log('Error', error.message);
                        than.$message({
                            message: '检查域名是否正确',
                            type: 'error'
                        });
                    }
                    console.log(error.config);
                });
        },
        get_weigh_detail(row) {
            this.get_weighTableVisible = true
            this.weigh_detail_res = row
        },
        get_delivery() {
            const than = this
            axios.get(this.baseInfo.baseUrl + "/open/stuffRecord/delivery/get", {
                headers: { 'token': this.baseInfo.baseToken },
            })
                .then(res => {
                    if (res.data.code == 0) {
                        this.delivery_res = res.data.data
                        console.log(res.data.data)
                        // than.$message({
                        //     message: res.data.msg,
                        //     type: 'success'
                        // });
                    } else {
                        than.$message({
                            message: res.data.msg,
                            type: 'error'
                        });
                    }

                })
                .catch(function (error) {
                    if (error.response) {
                        // 请求成功发出且服务器也响应了状态码，但状态代码超出了 2xx 的范围
                        than.$message({
                            message: error.response.data.msg,
                            type: 'error'
                        });
                        console.log(error.response.data);
                        console.log(error.response.status);
                        console.log(error.response.headers);
                    } else if (error.request) {
                        // 请求已经成功发起，但没有收到响应
                        // `error.request` 在浏览器中是 XMLHttpRequest 的实例，
                        // 而在node.js中是 http.ClientRequest 的实例
                        console.log(error.request);
                        console.log("error.request");
                    } else {
                        // 发送请求时出了点问题
                        console.log('Error', error.message);
                        than.$message({
                            message: '检查域名是否正确',
                            type: 'error'
                        });
                    }
                    console.log(error.config);
                });
        },
        get_delivery_detail(row) {
            this.get_deliveryTableVisible = true
            this.delivery_detail_res = row
        },
        get_stuffRecord(current) {
            const than = this
            let readyData = JSON.stringify({
                "current": this.stuffRecord_page,
                "extra": {},
                "model": {
                    "stuffCode": this.formInline.stuffCode,
                    "batchNo": this.formInline.batchNo,
                },
                "order": "descending",
                "size": 10,
                "sort": "createTime"
            })
            axios.post(this.baseInfo.baseUrl + "/open/stuffRecord/fullQueryPage", readyData, {
                headers: {
                    'token': this.baseInfo.baseToken,
                    'Content-Type': "application/json"
                },
            })
                .then(res => {
                    if (res.data.code == 0) {
                        this.stuffRecord_res = res.data.data.records
                        this.stuffRecord = res.data.data
                        // console.log(this.stuffRecord_res)
                        console.log(res)
                        // than.$message({
                        //     message: res.data.msg,
                        //     type: 'success'
                        // });
                    } else {
                        than.$message({
                            message: res.data.msg,
                            type: 'error'
                        });
                    }
                })
                .catch(function (error) {
                    if (error.response) {
                        // 请求成功发出且服务器也响应了状态码，但状态代码超出了 2xx 的范围
                        than.$message({
                            message: error.response.data.msg,
                            type: 'error'
                        });
                        console.log(error.response.data);
                        console.log(error.response.status);
                        console.log(error.response.headers);
                    } else if (error.request) {
                        // 请求已经成功发起，但没有收到响应
                        // `error.request` 在浏览器中是 XMLHttpRequest 的实例，
                        // 而在node.js中是 http.ClientRequest 的实例
                        console.log(error.request);
                        console.log("error.request");
                    } else {
                        // 发送请求时出了点问题
                        console.log('Error', error.message);
                        than.$message({
                            message: '检查域名是否正确',
                            type: 'error'
                        });
                    }
                    console.log(error.config);
                });
        },
        get_stuffRecord_detail(row) {
            this.get_stuffRecordTableVisible = true
            this.stuffRecord_detail_res = row.materials
            this.stuffRecord_res_select = row
            // console.log(row.materials)
            // console.log(stuffRecord_res)
        },
        // 分页
        handleCurrentChange(val) {
            this.stuffRecord_page = val;
            this.get_stuffRecord();
        },

        // 料单
        get_SyncList() {
            const than = this
            let readyData = JSON.stringify({
                "deviceType": this.stuffRecord_list.deviceType,
                "startTime": this.stuffRecord_list.startTime,
                "endTime": this.stuffRecord_list.endTime,
            })
            axios.post(this.baseInfo.baseUrl + "/open/stuffRecord/getSyncList", readyData, {
                headers: {
                    'token': this.baseInfo.baseToken,
                    'Content-Type': "application/json"
                },
            })
                .then(res => {
                    if (res.data.code == 0) {
                        this.stuffRecord_list.res_data = res.data.data
                        // console.log("123")
                        // console.log(res.data.data)
                    } else {
                        than.$message({
                            message: res.data.msg,
                            type: 'error'
                        });
                    }
                })
                .catch(function (error) {
                    if (error.response) {
                        // 请求成功发出且服务器也响应了状态码，但状态代码超出了 2xx 的范围
                        than.$message({
                            message: error.response.data.msg,
                            type: 'error'
                        });
                        console.log(error.response.data);
                        console.log(error.response.status);
                        console.log(error.response.headers);
                    } else if (error.request) {
                        // 请求已经成功发起，但没有收到响应
                        // `error.request` 在浏览器中是 XMLHttpRequest 的实例，
                        // 而在node.js中是 http.ClientRequest 的实例
                        console.log(error.request);
                        console.log("error.request");
                    } else {
                        // 发送请求时出了点问题
                        console.log('Error', error.message);
                        than.$message({
                            message: '检查域名是否正确',
                            type: 'error'
                        });
                    }
                    console.log(error.config);
                });
        },

        btn_update_weigh() {

            let up_materials = []
            for (const item in this.stuffRecord_detail_res) {
                const obj = {}
                obj["materialCode"] = this.stuffRecord_detail_res[item].materialCode
                obj["actualIngredients"] = this.stuffRecord_detail_res[item].actualIngredients
                obj["transferStatus"] = this.stuffRecord_detail_res[item].transferStatus
                up_materials.push(obj)
            }
            // console.log(up_materials)

            let update_res = {
                "materials": up_materials,
                "stuffCode": this.stuffRecord_res_select.stuffCode,
                "stuffStepUid": this.stuffRecord_res_select.stuffStepUid,
                "weighEndTime": this.stuffRecord_res_select.weighEndTime,
                "weighStartTime": this.stuffRecord_res_select.weighStartTime,
                "weighingCode": this.stuffRecord_res_select.weighingCode,
                "weighingStatus": this.stuffRecord_res_select.weighingStatus
            }
            console.log("---请求参数---")
            console.log(update_res)
            this.update_weigh()

        },
        btn_update_delivery() {

            let up_materials = []
            for (const item in this.stuffRecord_detail_res) {
                const obj = {}
                obj["materialCode"] = this.stuffRecord_detail_res[item].materialCode
                obj["actualIngredients"] = this.stuffRecord_detail_res[item].actualIngredients
                obj["transferStatus"] = this.stuffRecord_detail_res[item].transferStatus
                up_materials.push(obj)
            }
            console.log(up_materials)

            let update_res = {
                "materials": up_materials,
                "batchNo": this.stuffRecord_res_select.batchNo,
                "stuffCode": this.stuffRecord_res_select.stuffCode,
                "stuffStepUid": this.stuffRecord_res_select.stuffStepUid,
                "weighEndTime": this.stuffRecord_res_select.deliveryEndTime,
                "weighStartTime": this.stuffRecord_res_select.deliveryStartTime,
                "weighingCode": this.stuffRecord_res_select.deliveryCode,
                "weighingStatus": this.stuffRecord_res_select.deliveryStatus
            }
            console.log("---请求参数---")
            console.log(update_res)
            // 调用API配送
            this.update_delivery()

        },

        // 【称料】更新称料状态
        update_weigh() {
            const than = this
            let readyData = this.stuffRecord_res_select
            axios.post(this.baseInfo.baseUrl + "/open/stuffRecord/weigh/update", readyData, {
                headers: {
                    'token': this.baseInfo.baseToken,
                    'Content-Type': "application/json"
                },
            })
                .then(res => {
                    // console.log(res)
                    if (res.data.code == 0) {
                        console.log("更新称料成功")
                        than.$message({
                            message: '更新称料成功',
                            type: 'success'
                        });
                    } else {
                        than.$message({
                            message: res.data.msg,
                            type: 'error'
                        });
                    }

                })
                .catch(function (error) {
                    if (error.response) {
                        // 请求成功发出且服务器也响应了状态码，但状态代码超出了 2xx 的范围
                        than.$message({
                            message: error.response.data.msg,
                            type: 'error'
                        });
                        console.log(error.response.data);
                        console.log(error.response.status);
                        console.log(error.response.headers);
                    } else if (error.request) {
                        // 请求已经成功发起，但没有收到响应
                        // `error.request` 在浏览器中是 XMLHttpRequest 的实例，
                        // 而在node.js中是 http.ClientRequest 的实例
                        console.log(error.request);
                        console.log("error.request");
                    } else {
                        // 发送请求时出了点问题
                        console.log('Error', error.message);
                        than.$message({
                            message: '检查域名是否正确',
                            type: 'error'
                        });
                    }
                    console.log(error.config);
                });
        },
        // 【配送】更新配送状态
        update_delivery() {
            const than = this
            let readyData = this.stuffRecord_res_select
            axios.post(this.baseInfo.baseUrl + "/open/stuffRecord/delivery/update", readyData, {
                headers: {
                    'token': this.baseInfo.baseToken,
                    'Content-Type': "application/json"
                },
            })
                .then(res => {
                    // console.log(res)
                    if (res.data.code == 0) {
                        console.log("更新配送成功")
                        than.$message({
                            message: '更新配送成功',
                            type: 'success'
                        });
                    } else {
                        than.$message({
                            message: res.data.msg,
                            type: 'error'
                        });
                    }

                })
                .catch(function (error) {
                    if (error.response) {
                        // 请求成功发出且服务器也响应了状态码，但状态代码超出了 2xx 的范围
                        than.$message({
                            message: error.response.data.msg,
                            type: 'error'
                        });
                        console.log(error.response.data);
                        console.log(error.response.status);
                        console.log(error.response.headers);
                    } else if (error.request) {
                        // 请求已经成功发起，但没有收到响应
                        // `error.request` 在浏览器中是 XMLHttpRequest 的实例，
                        // 而在node.js中是 http.ClientRequest 的实例
                        console.log(error.request);
                        console.log("error.request");
                    } else {
                        // 发送请求时出了点问题
                        console.log('Error', error.message);
                        than.$message({
                            message: '检查域名是否正确',
                            type: 'error'
                        });
                    }
                    console.log(error.config);
                });
        },
        // 获取设备ID
        get_Device() {
            const than = this
            axios({
                url: this.baseInfo.baseUrl + "/open/datav/eam/device/monitor",
                params: {
                    deviceType: "DYEING",
                    spaceId: "",
                    tagNames: ""
                },
                headers: {
                    "token": this.baseInfo.baseToken
                }
            })
                .then(res => {
                    console.log(res);
                    if (res.data.code == 0) {
                        console.log("获取设备ID成功");
                        const dres = res.data.data
                        console.log(typeof dres)
                        const strDict = {};
                        for (var i = 0, len = dres.length; i < len; i++) {
                            // console.log(dres[i]);
                            strDict[dres[i].klinxDeviceName] = dres[i].klinxDeviceId;
                        };
                        than.device = JSON.stringify(strDict, null, "\t");
                        than.$message({
                            message: '获取设备ID成功',
                            type: 'success'
                        });
                    } else {
                        than.$message({
                            message: res.data.msg,
                            type: 'error'
                        });
                    }
                })
                .catch(function (error) {
                    if (error.response) {
                        // 请求成功发出且服务器也响应了状态码，但状态代码超出了 2xx 的范围
                        than.$message({
                            message: error.response.data.msg,
                            type: 'error'
                        });
                        console.log(error.response.data);
                        console.log(error.response.status);
                        console.log(error.response.headers);
                    } else if (error.request) {
                        // 请求已经成功发起，但没有收到响应
                        // `error.request` 在浏览器中是 XMLHttpRequest 的实例，
                        // 而在node.js中是 http.ClientRequest 的实例
                        console.log(error.request);
                        console.log("error.request");
                    } else {
                        // 发送请求时出了点问题
                        console.log('Error', error.message);
                        than.$message({
                            message: '检查域名是否正确',
                            type: 'error'
                        });
                    }
                    console.log(error.config);
                });
        }
    }
}
</script>

<style>
.el-col {
    border-radius: 4px;
}

.bg-purple-dark {
    background: #99a9bf;
}

.bg-purple {
    background: #d3dce6;
}

.bg-purple-light {
    background: #e5e9f2;
}

.grid-content {
    border-radius: 4px;
    min-height: 36px;
}

.row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
}
</style>


// WEBPACK FOOTER //
// src/itex_cms.vue